import { connect } from "react-redux";
import PaymentRequest from "./paymentRequest";
import { bindActionCreators } from "redux";
import { getPaymentRequest } from "services/redux/sales/businessListing/action";

import {
  fetchZones,
  getListFilterData,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  postSalesList: state.approvedSalesListReducer.postSalesList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getListFilterData,
      fetchZones,
      getPaymentRequest,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PaymentRequest);
